import React, { useState } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { connect, Provider } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { ensureBoolean, getLayout, getRemotedbUrl, getStageName, i18nIntl, isNotEmpty, NSchange, parseVideo, preventSelection, throwErrorEvent } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';
import { stage_types, stage_categories, stage_promotion_types as spt, visible_stage_categories, isMultiStage } from '../../data/bootstrap_stages';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';

import { CreateButton, MainButton, SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import { DeleteButton } from '../builder/ConfirmButton';
import DatesMap from '../builder/DatesMap';
import DisabledArea from '../builder/DisabledArea';
import FloatingLayer from '../builder/FloatingLayer';
import Message, { AlertMessage, SuccessMessage } from '../builder/Message';
import { NavigationTabsBuilder } from '../builder/NavigationTabs';
import SaveButton from '../builder/SaveButton';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';
import Select from '../builder/Select';
import ToggleButton from '../builder/ToggleButton';
import Tooltip from '../builder/Tooltip';
import { BuilderMainWithoutSidebar } from '../builder/BuilderMain.js';

import BracketsBuilder from '../../containers/BracketsBuilder';
import StageContentCategories from '../../containers/StageContentCategories.js';
import StageEdit from './StageEdit';
import StageGalleries from '../../containers/StageGalleries.js';
import StageManager from '../../containers/StageManager';
import StageManagerEdit from '../../containers/StageManagerEdit';
import StageSections from '../../containers/StageSections';

import { SegmentRibbons } from './elements/SegmentBuilder.js';

import StageTeamsManagement from '../../containers/StageTeamsManagement.js';

const DragHandle = SortableHandle(() => <div class="sorter_target" />);

export const sortStages = (stages,order_mode) => {
	if(order_mode != undefined && order_mode == 'manual') {
		return stages.sort((a, b) => (parseInt(a.Stage.pos) < parseInt(b.Stage.pos) ? -1 : 1));
	}

	return stages.sort((a, b) => {
		switch (order_mode) {
			case 'date':
			default:
				if(a.Stage.start_date == b.Stage.start_date) return (a.Stage.id < b.Stage.id) ? -1 : 1;
				return (a.Stage.start_date < b.Stage.start_date) ? -1 : 1;

			case 'date_inv':
				return (a.Stage.start_date > b.Stage.start_date) ? -1 : 1;

			case 'title':
				return (a.Stage?.display_title < b.Stage?.display_title) ? -1 : 1;

			case 'title_inv':
				return (a.Stage?.display_title > b.Stage?.display_title) ? -1 : 1;
		}
	}).slice(0);
}

export const StageScoreRecalculate = ({promotion,stage, ...props}) =>{
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_recalculate, setDisplayRecalculate ] = useState(false);
	const [ recalculation_resumee, setRecalculationResumee ] = useState(false);
	const [ is_recalculating, setIsRecalculating ] = useState(false);
	const [ last_update_recalculate, setLastUpdateRecalculate ] = useState(stage.score_last_update)
	const [ score_update_error, setScoreUpdateError ] = useState(null)
	
	const is_score_predictor = [spt.SCORE_PREDICTOR.id].includes(parseInt(stage.promotion_type_id));
	const is_pick_favorite = [spt.PICK_FAVORITE.id].includes(parseInt(stage.promotion_type_id));
	const is_predictions = [spt.PREDICTIONS.id].includes(parseInt(stage.promotion_type_id));
	const is_knowledge_quiz = [spt.KNOWLEDGE_QUIZ.id].includes(parseInt(stage.promotion_type_id));
	const is_team = [spt.TEAM.id].includes(parseInt(stage.promotion_type_id));
	const is_one_bracket = [ spt.BRACKET_PREDICTOR.id].includes(parseInt(stage.promotion_type_id));
	
	const recalculate = (cb) => {
		setIsRecalculating(true);

		if(is_score_predictor || is_pick_favorite || is_one_bracket) {

			const do_recalculate = (cb) => {
				$.get(getRemotedbUrl(`/v24/stages/recalculate_stage_score/${stage.promotion_id}/${stage.id}`), (res) => {
					if(res.status) {
						setRecalculationResumee(res);
						if(res.last_update) setLastUpdateRecalculate(res.last_update);
					} else {
						setScoreUpdateError(res.reason);
					}
					setIsRecalculating(false);
					if(cb != undefined) cb();
				}, 'JSON');
			}

			if(props.previous_cb != undefined){
				props.previous_cb(()=>do_recalculate(cb));
			}else{
				do_recalculate(cb);
			}
			return;
		}
		
		if(is_predictions || is_knowledge_quiz) {
			$.post(getRemotedbUrl(`/quizs/recalculate/${stage.promotion_id}/${stage.id}`), (res) => {
				setRecalculationResumee({ updated:res.changed });
				setIsRecalculating(false);
				if(cb != undefined) cb();
			}, 'JSON');
			return;
		}
		
		if(is_team) {
			$.post(getRemotedbUrl(`/stages/recalculate_team/${stage.promotion_id}/${stage.id}`), (res) => {
				setRecalculationResumee(res);
				setIsRecalculating(false);
				if(cb != undefined) cb();
			}, 'JSON');
			return;
		}

		setIsRecalculating(false);
		if(cb != undefined) cb();
	};
	
	const stage_start_date = (stage.start_date == '0000-00-00 00:00:00' || !stage.start_date) ? promotion.start_entry : stage.start_date;
	let stage_started = (EPDateAfter(null, stage_start_date) || !isMultiStage(promotion.promotion_type_id)) ? true : false;
	if(props?.disabled ?? false)stage_started=false;
	const squared = props?.squared ?? false;
	
	const tz = promotion?.timezone ?? 'Europe/Madrid';
	const last_update_tz = EPGetTimezone(last_update_recalculate, tz, 'LLL');

	const button_props = {
		icon:props?.icon ?? 'knk-reload',
		onClick:() => setDisplayRecalculate(true),
		tooltip:<Tooltip
			with_icon={false}
			position="top"
		>{(stage_started) ? "Update participants' scores" : "This action will be enabled once the stage finishes"}</Tooltip>,
		disabled:(!stage_started) ? true : false,
	};

	return (
		<>
			{(squared === false) && (
				<>
					<ButtonCollection
						_class={{ other:'not_in_top' }}
					>
						<MainButton
							{...button_props}
						>Update scores</MainButton>
					</ButtonCollection>

					{(last_update_recalculate) && (
						<div class="gui_not_in_top_tiny gui_small_text">
							<p>
								<FormattedMessage
									id="Last update: {date}"
									values={{
										date:<strong>{last_update_tz}</strong>,
									}}
								/>
							</p>

							<p>[{window?.visible_timezones?.[tz] ?? tz}]</p>
						</div>
					)}
				</>
			)}

			{(squared) && (
				<MainButton
					{...button_props}
					squared={true}
				/>
			)}

			{(display_recalculate) && (
				<FloatingLayer
					_class={{size:'small'}}
					enable_close={(is_recalculating) ? false : true}
					backButton={(!is_recalculating !== false) ? () => setDisplayRecalculate(false) : null}
				>
					<div>
						<SectionTitle
							_class={{ icon:'knk-reload' }}
						>Recalculate scores for participants</SectionTitle>

						{(recalculation_resumee !== false) && (
							<>
								<SuccessMessage
									_class={{ other:'in_top in_bottom' }}
								>
									<p>
										<FormattedMessage
											id={"Operation successful: {total_changed} users updated{extra_label}"}
											values={{
												total_changed:recalculation_resumee?.updated ?? 0,
												extra_label:(recalculation_resumee?.updated ?? 0) == '0' ? ` (${i18n("no changes needed")})` : '',
											}}
										/>
									</p>
								</SuccessMessage>
								

								<ButtonCollection in_floating={true}>
									<MainButton
										onClick={() => {
											setDisplayRecalculate(false);
											setRecalculationResumee(false);
										}}
									>Done!</MainButton>
								</ButtonCollection>
							</>
						)}

						{(recalculation_resumee === false) && (
							<>
								<SectionSubtitle>This process might take a while.</SectionSubtitle>

								{!(score_update_error) ? (
									<Message
										_class={{ other:'in_top in_bottom' }}
									>
										<p>{i18n("Please don't close this layer or refresh the page until the end confimation appears.")}</p>
									</Message>
								) : (
									<AlertMessage
									_class={{ other:'in_top in_bottom' }}
									>
										<p>
											{(score_update_error == 'points') && i18n("Points for results not set.")}
											{(score_update_error == 'results') && i18n("Match results not set.")}
											{(score_update_error == 'default') && i18n("Matches or teams not set.")}
										</p>
									</AlertMessage>
								)}

								<ButtonCollection in_floating={true}>
									{(!score_update_error) && (
										<SaveButton
											onClick={(e, cb) => recalculate(cb)}
										>Update scores</SaveButton>
									)}

									<SecondaryButton
										disabled={is_recalculating}
										onClick={() => {setDisplayRecalculate(false); setScoreUpdateError(null)}}
									>Close</SecondaryButton>
								</ButtonCollection>
							</>
						)}
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

const SortableFields = SortableContainer(({ items, brackets, data, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, data.intl, c);

	const section = (data.section != undefined && data.section.title != undefined) ? data.section : false;

	const is_sections_enabled = data?.is_sections_enabled ?? false;
	const is_sortable = (data.is_sortable != undefined && data.is_sortable == 'manual' && !is_sections_enabled) ? true : false;

	return (
		<div class="group_tabled_items">
			<ul class="gui_sortable_table">
				<li class="gui_sortable_table_header">
					<div style={{ flexGrow:'1', minWidth:(is_sortable) ? 'calc(150px + 20px + 1em)' : '150px' }}>
						{(section.title != undefined) && (
							<>
								<span class="stage_status"><span class="section_status ep-circle" style={{ color: section.color }} /></span>

								{(section.title != "") ? (
									section.title
								) : (
									<>{i18n("Section")} #{props?.index ?? 1}</>
								)}
							</>
						)}

						{(section.title == undefined) && (
							i18n("Stage")
						)}
					</div>

					{(data.is_multistage) && (
						<div style={{ flexBasis:'155px', flexShrink:'0' }}>{i18n("Status")}</div>
					)}

					{(data.is_multistage) && (
						<div style={{ flexBasis:'130px', flexShrink:'0' }}>{i18n("Start date")}</div>
					)}

					{(data.is_multistage) && (
						<div style={{ flexBasis:'130px', flexShrink:'0' }}>{i18n("End date")}</div>
					)}

					<div class="content" style={{ flexBasis:'160px', flexShrink:'0' }}>{i18n("participations", 'ucfirst')}</div>

					{(!data.is_multistage) && (
						<div class="content" style={{ flexBasis:'160px', flexShrink:'0' }}>{i18n("Frequency of participation")}</div>
					)}

					<div class="gui_text_align_end" style={{ flexBasis:'220px', flexShrink:'0' }}>{i18n("Actions")}</div>
				</li>
			</ul>

			<ul class="gui_sortable_table">
				{items.map((st, s) => {
					return (
						<SortableItem
							key={`item-${s}`}
							index={s}
							stage={st.Stage}
							brackets={brackets}
							{...data}
						/>
					)
				})}
			</ul>
		</div>
	);
});

const SortableItem = SortableElement((props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stage = props.stage;

	const is_sections_enabled = props?.is_sections_enabled ?? false;

	let stage_type = props.get_stage_type(stage.promotion_type_id);
	if(stage_type == undefined) stage_type = {};

	const is_wl = props?.is_wl ?? false;
	const is_draft = props?.is_draft ?? false;
	const promotion_type_id = props?.promotion_type_id ?? false;

	let enable_stage_type_change = ([33, 46].includes(parseInt(promotion_type_id))) ? true : false;
	if(!enable_stage_type_change){
		//Validate Receipt + Type Direct
		enable_stage_type_change = is_wl && [38].includes(parseInt(promotion_type_id)) && stage.type == '1' ? true : false;
	}

	let stage_icon;
	switch(stage.promotion_type_id) {
		case '5':
		case '6':
		case '7':
		case '8':
		case '9':
			stage_icon = (props.is_multistage) ? stage_type.icon_class : 'knk-to-do-list';
			break;

		default:
			stage_icon = stage_type?.icon_class ?? 'knk-alert redIcon';
			break;
	}

	let pf = props.participation_frequencies.filter((f) => (f.k == stage.participation_frequency) ? true : false);
	pf = (pf.length > 0) ? pf[0].v : '';

	let edit_link = `#stages/${stage.id}/options`;
	if(stage.promotion_type_id == spt.MEDIA_AUTOCONTENT.id) edit_link = `#stages/${stage.id}/media/candidates`

	const start_date_out_of_range = (EPDateBefore(stage.start_date, props.start_date) || EPDateAfter(stage.start_date, props.end_date)) ? true : false;
	const end_date_out_of_range = (EPDateBefore(stage.end_date, props.start_date) || EPDateAfter(stage.end_date, props.end_date)) ? true : false;

	//const stage_start_date = (stage.start_date == '0000-00-00 00:00:00' || !stage.start_date) ? props.start_entry : stage.start_date;
	//const stage_started = (EPDateAfter(null, stage_start_date) || !props.is_multistage) ? true : false;
	const closed = (EPDateBefore(stage.end_date)) ? true : false;
	const promo_type_id = parseInt(stage.promotion_type_id);
	const recalculate_stages = [
		spt.PREDICTIONS.id, 
		spt.KNOWLEDGE_QUIZ.id, 
		spt.TEAM.id,
		spt.BRACKET_PREDICTOR.id,
	];

	//Control Recalculate
	let has_recalculate = recalculate_stages.includes(promo_type_id);
	if([spt.SCORE_PREDICTOR.id].includes(promo_type_id) && closed) {
		has_recalculate = true;
	} else if([spt.PICK_FAVORITE.id].includes(promo_type_id) && closed && (stage?.faceoff_winner_result ?? false)) {
		has_recalculate = true;
	}

	const closed_no_prizes = !closed && (stage?.no_prize_closed ?? false) ? true : false;
	const open = !closed_no_prizes ? ((EPDateBefore(stage.start_date) && EPDateAfter(stage.end_date)) ? true : false) : false;
	const pending = (!open && !closed && !closed_no_prizes) ? true : false;

	const is_sortable = (props.is_sortable != undefined && props.is_sortable == 'manual' && !is_sections_enabled) ? true : false;
	const is_bracket = (stage.type == stage_categories.ID_BRACKET_CATEGORY.id) ? true : false;

	const is_jury = stage?.voting_jury_mode ?? false;

	const is_unknown = (stage_type.name == undefined) ? true : false;
	let display_title = i18n((isNotEmpty(stage, 'display_title')) ? stage.display_title : (stage_type?.name ?? "Unknown stage type"));
	if(is_bracket) {
		let title_bracket = (props.brackets).find((m) => m.Bracket.id == stage.bracket_id).Bracket['title'];
		display_title = title_bracket + " - " + display_title;
	}
	if(is_jury) display_title = `[${i18n("Jury")}] ${display_title}`;

	const next_stage = props.stages.find((s) => (s.Stage.id == stage.next_stage_id));
	const label_next = (next_stage) ? getStageName(next_stage.Stage, i18n) : false;

	let data_source = false;
	if(isNotEmpty(stage, 'voting_mirror') && props.media_list[stage.id] != undefined) data_source = props.media_list[stage.voting_mirror];

	const is_mention_hashtag = (promotion.Promotion.promotion_type_id == 58) ? true : false;
	const allow_delete_stage = !is_bracket && (!is_mention_hashtag || is_wl) ? true : false;

	return (
		<li class="gui_sortable_table_item">
			{(is_sortable) && (
				<DragHandle />
			)}

			<div style={{ flexGrow:'1', minWidth:'150px' }}>
				<span class={stage_icon + ' blueIcon gui_small_icon'} />

				<strong class="gui_pos_rel gui_flexbox" style={{ height:'1.5em' }}>
					{(!is_unknown) ? (
						<ActionLink
							icon={(is_jury) ? 'knk-toc' : null}
							_class={{ other:'gui_small_icon gui_cutTextOnOverflow' }}
							_href={edit_link}
						>{display_title}</ActionLink>
					) : (
						<>{display_title}</>
					)}
				</strong>

				{(label_next !== false) && (
					<em class="gui_small_text" style={{ marginInlineStart:'2em', display:'inline-block' }}>
						{i18n("Next")}: <span>{label_next}</span>
					</em>
				)}

				{(data_source !== false) && (
					<em class="gui_small_text" style={{ marginInlineStart:'2em', display:'inline-block' }}>
						{i18n("Display candidates from")}: <strong>{data_source}</strong>
					</em>
				)}

				{(stage.segment_id != undefined || stage.block_segment_id != undefined) && (
					<SegmentRibbons
						segments={stage.segment_id}
						blocked_segments={stage.block_segment_id}
						promotion_id={stage.promotion_id}
					/>
				)}
			</div>

			{(props.is_multistage) && (
				<div class="content" style={{ flexBasis:'155px', flexShrink:'0' }}>
					{(open) && (
						<span class="stage_status"><span class="section_status ep-circle greenIcon" />{i18n("open", 'ucfirst')}</span>
					)}

					{(pending) && (
						<span class="stage_status"><span class="section_status ep-circle orangeIcon" />{i18n("pending", 'ucfirst')}</span>
					)}

					{(closed) && (
						<span class="stage_status"><span class="section_status ep-circle redIcon" />{i18n("closed", 'ucfirst')}</span>
					)}
					
					{(closed_no_prizes) && (
						<span class="stage_status"><span class="section_status ep-circle yellowIcon" />{i18n("prizes used up", 'ucfirst')}</span>
					)}
				</div>
			)}

			{(props.is_multistage) && (
				<div class={'content' + ((start_date_out_of_range) ? ' redColor' : '')} style={{ flexBasis:'130px', flexShrink:'0' }}>
					{(start_date_out_of_range) && (
						<Tooltip
							position="top"
							icon="error_field_icon knk-alert gui_small_icon redIcon"
						>Out of promotion publication dates</Tooltip>
					)}

					{EPDateFormat(stage.start_date, 'L')}
				</div>
			)}

			{(props.is_multistage) && (
				<div class={'content' + ((end_date_out_of_range) ? ' redColor' : '')} style={{ flexBasis:'130px', flexShrink:'0' }}>
					{(end_date_out_of_range) && (
						<Tooltip
							position="top"
							icon="error_field_icon knk-alert gui_small_icon redIcon"
						>Out of promotion publication dates</Tooltip>
					)}

					{EPDateFormat(stage.end_date, 'L')}
				</div>
			)}

			<div class="content" style={{ flexBasis:'160px', flexShrink:'0' }}>
				<span>{stage.max_participations}</span>

				{(props.is_multistage) && (
					<span class="gui_not_in_start">({i18n(pf)})</span>
				)}
			</div>

			{(!props.is_multistage) && (
				<div class="content" style={{ flexBasis:'130px', flexShrink:'0' }}>{i18n(pf)}</div>
			)}

			<ButtonCollection _class={{ other:'gui_flex_end' }} style={{ flexBasis:'220px', flexShrink:'0' }}>
				{(has_recalculate && !is_bracket) && (
					<StageScoreRecalculate
						promotion={promotion}
						stage={stage}
						squared={true}
						intl={props.intl}
					/>
				)}

				{(enable_stage_type_change && (is_draft || ((window?.server_type ?? '0') != '0') || (window?.is_admin ?? false))) && (
					<SquaredButton
						icon='knk-sorter-arrow-h'
						tooltip={<Tooltip
							with_icon={false}
							position="top"
						>Change stage type</Tooltip>}
						onClick={() => props.promote(stage.id)}
						aria-label="Change stage type"
					/>
				)}

				{(props.is_multistage) && (
					<ToggleButton
						squared={true}
						active={!(stage?.hide_stage ?? false)}
						icon='knk-visible'
						icon_off='knk-invisible redIcon'
						tooltip={<Tooltip
							with_icon={false}
							position="top"
						>{(stage.hide_stage == undefined || !stage.hide_stage) ? "The stage is visible" : "The stage is NOT visible"}</Tooltip>}
						onClick={() => props.toggle_hide_stage(stage.id)}
						aria-label="Toggle visibility"
					/>
				)}

				{(props.is_multistage && !is_bracket && is_wl) && (
					<SquaredButton
						icon='knk-copy'
						onClick={(!is_unknown) ? () => props.copy_stage(stage.id) : null}
						disabled={(is_unknown) ? true : false}
						aria-label="Copy"
					/>
				)}

				<SquaredButton
					_href={(!is_unknown) ? edit_link : null}
					disabled={(is_unknown) ? true : false}
					icon='knk-edit'
					aria-label="Edit"
				/>

				{(allow_delete_stage) && (
					<DeleteButton
						squared={true}
						disabled={(props.is_multistage) ? false : true}
						_position="left"
						onClick={() => props.delete_stage(stage.id)}
						aria-label="Delete"
					/>
				)}
			</ButtonCollection>
		</li>
	)
});

const CreateStageOverlay = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ selectedStage, selectStage ] = useState(false);

	const promo_type = props?.promo_type ?? false;

	const promotion_types = props?.promotion_types ?? [];
	const _sorted_stage_types = {};
	props.stage_types.map((st) => {
		if(st.visible_category == undefined) return;

		if(_sorted_stage_types[st.visible_category.type] == undefined) {
			_sorted_stage_types[st.visible_category.type] = {
				id:st.visible_category.id,
				name:i18n(st.visible_category.label),
				types:[],
			};
		}

		const is_enabled_type = (st.enabled_promo_types.length > 0) ? ((st.enabled_promo_types.find((obj) => (obj == promo_type)) != undefined) ? true : false) : false;
		if(!is_enabled_type) return;

		_sorted_stage_types[st.visible_category.type].types.push(st);
	});

	const sorted_stage_types = Object.values(_sorted_stage_types).sort((a, b) => {
		return (a.id < b.id) ? -1 : 1;
	});

	const not_empty_stage_types = sorted_stage_types.filter((s) => {
		return (s.types.length > 0) ? true : false;
	});

	const hide_sections = [];	// all in
	const hide_types = [];		// all in

	return (
		<FloatingLayer _class={{ size: 'small' }} backButton={() => props.closeCreateStageLayer()}>
			<div>
				<SectionTitle>Select the type of stage</SectionTitle>

				<div class="gui_overflowed_auto" style={{maxHeight:'calc(100dvh - 350px)'}}>
					{not_empty_stage_types.map((st, s) => {
						if(hide_sections.includes(st.id)) return null;

						return (
							<div class="stage_category" key={`category_${s}`}>
								{(not_empty_stage_types.length > 1) && (
									<h3 class="title">{st.name}</h3>
								)}

								<ul class="items_with_icon_selector stage_selector">
									{st.types.map((pt, i) => {
										const promotion_type = promotion_types.find((o) => (o.id == pt.id));
										const is_debug = ensureBoolean(promotion_type?.is_debug ?? '0');
										const enforce_display = ensureBoolean(pt?.enforce_display ?? false);
										if(is_debug && !enforce_display && window.server_type == '0') return null;
										
										const hide_type = pt?.hide ?? false;
										if(hide_type && window.server_type == '0') return null;
										
										if(hide_types.includes(pt.id)) return null;

										const selected = (selectedStage.id === pt.id) ? true : false;

										const color = (selected) ? 'rgba(var(--main-color), 1)' : 'rgba(var(--main-bg-color), 1)';

										const _classes = [];
										if(selected) _classes.push('selected');

										return (
											<li key={i} class={_classes.join(" ")} onClick={() => selectStage(pt)}>
												<span class={'promo_type_icon gui_circled_icon mainTextIcon ' + pt.icon_class}>
													<span class="bg" style={{ backgroundColor:color }} />
												</span>

												<span class="name">{i18n(pt.name)}</span>
											</li>
										)
									})}
								</ul>
							</div>
						)
					})}
				</div>

				<ButtonCollection in_floating={true}>
					<SaveButton
						disabled={(selectedStage === false) ? true : false}
						onClick={(e, cb) => props.createStage(selectedStage, cb)}
						autotranslate={false}
					>{(selectedStage === false) ? i18n("Create stage") : <FormattedMessage id="Create {type} stage" values={{ type: `"${i18n(selectedStage.name)}"` }} />}</SaveButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
};

const PromoteStageOverlay = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ selectedStage, selectStage ] = useState(false);

	const promo_type = props?.promo_type ?? false;
	const actual_stage = props?.actual_stage ?? false;

	const promotion_types = props?.promotion_types ?? [];
	const _sorted_stage_types = {};
	props.stage_types.map((st) => {
		if(st.visible_category == undefined) return;

		if(_sorted_stage_types[st.visible_category.type] == undefined) {
			_sorted_stage_types[st.visible_category.type] = {
				id:st.visible_category.id,
				name:i18n(st.visible_category.label),
				types:[],
			};
		}

		const is_enabled_type = (st.enabled_promo_types.length > 0) ? ((st.enabled_promo_types.find((obj) => (obj == promo_type)) != undefined) ? true : false) : false;
		const is_ticket_validation = props.promo_type == 38 && actual_stage.Stage.type == 1;//Validate Receipt + Type Direct
		if(!is_enabled_type && !is_ticket_validation) return;

		_sorted_stage_types[st.visible_category.type].types.push(st);
	});
	const sorted_stage_types = Object.values(_sorted_stage_types).sort((a, b) => {
		return (a.id < b.id) ? -1 : 1;
	});

	const not_empty_stage_types = sorted_stage_types.filter((s) => {
		return (s.types.length > 0) ? true : false;
	});

	const hide_sections = [
		visible_stage_categories.ID_MEDIA_CATEGORY.id,
	];

	const hide_types = [
		spt.TEAM.id,
		spt.BRACKET_PREDICTOR.id,
	];

	const actual_stage_type = i18n(stage_types.find((g) => (g.id == actual_stage.Stage.promotion_type_id)).name);
	const actual_stage_name = getStageName(actual_stage.Stage, i18n);

	return (
		<FloatingLayer _class={{ size: 'small' }} backButton={props.close}>
			<div>
				<SectionTitle>Change the type of participation</SectionTitle>

				{(actual_stage_type != actual_stage_name) ? (
					<SectionSubtitle
						autotranslate={false}
					><FormattedMessage
						id="You are changing the type of participation for the stage {name} (type: {type})."
						values={{
							name:<strong>{actual_stage_name}</strong>,
							type:<strong>{actual_stage_type}</strong>,
						}}
					/></SectionSubtitle>
				) : (
					<SectionSubtitle
						autotranslate={false}
					><FormattedMessage
						id="You are changing the type of participation for the stage {name}."
						values={{
							name:<strong>{getStageName(actual_stage.Stage, i18n)}</strong>,
						}}
					/></SectionSubtitle>
				)}

				<SectionSubtitle>You can only change it while the promotion is in draft.</SectionSubtitle>

				<SectionSubtitle
					_class={{ other: 'gui_not_in_bottom_big' }}
					autotranslate={false}
				>{i18n("Select the new type of participation")}:</SectionSubtitle>

				<div class="gui_overflowed_auto" style={{maxHeight:'calc(100dvh - 350px)'}}>
					{not_empty_stage_types.map((st, s) => {
						if(hide_sections.includes(st.id)) return null;

						return (
							<div class="stage_category" key={`category_${s}`}>
								{(not_empty_stage_types.length > 1) && (
									<h3 class="title">{st.name}</h3>
								)}

								<ul class="items_with_icon_selector stage_selector">
									{st.types.map((pt, i) => {
										const promotion_type = promotion_types.find((o) => (o.id == pt.id));
										const is_debug = ensureBoolean(promotion_type?.is_debug ?? '0');
										const enforce_display = ensureBoolean(pt?.enforce_display ?? false);
										if(is_debug && !enforce_display && window.server_type == '0') return null;
										
										const hide_type = pt?.hide ?? false;
										if(hide_type && window.server_type == '0') return null;

										if(hide_types.includes(pt.id)) return null;
										
										const is_actual_type = (pt.id == actual_stage.Stage.promotion_type_id) ? true : false;

										const selected = (selectedStage.id === pt.id) ? true : false;

										const color = (selected) ? 'rgba(var(--main-color), 1)' : 'rgba(var(--main-bg-color), 1)';

										const _classes = [];
										if(selected) _classes.push('selected');
										if(is_actual_type) _classes.push('is_actual_type');

										return (
											<li key={i} class={_classes.join(" ")} onClick={() => selectStage(pt)}>
												<span class={'promo_type_icon gui_circled_icon mainTextIcon ' + pt.icon_class}>
													<span class="bg" style={{ backgroundColor: color }} />
												</span>
												<span class="name">{i18n(pt.name)}</span>
											</li>
										)
									})}
								</ul>
							</div>
						)
					})}
				</div>

				<ButtonCollection in_floating={true}>
					<SaveButton
						disabled={(selectedStage === false) ? true : false}
						onClick={(e, cb) => props.createStage(selectedStage, props.stage_id, cb)}
						autotranslate={false}
						type='confirm'
					>{(selectedStage === false) ? i18n("Convert stage") : <FormattedMessage id="Convert the stage to {type}" values={{ type: `"${i18n(selectedStage.name)}"` }} />}</SaveButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
};

const StagesBuilder = (props) => {
	useCSS('comp/cards.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const published = (props.pm.attributes.hide_enter_button == '0') ? true : false;

	const [ display_create_stage_layer, setDisplayCreateStageLayer ] = useState(false);
	const [ promote_stage_id, setPromoteStageID ] = useState(false);
	const [ display_expired_stages, setDisplayExpiredStages ] = useState(true);
	const [ display_recalculate, setDisplayRecalculate ] = useState(false);
	const [ promotion, setPromotion ] = useState(props.pm.toJSON());
	const [ stage_recalculate_id, setStageRecalculateID ] = useState(false);
	const [ stage_recalculate_changed, setStageRecalculateChanged ] = useState(-1);

	const sortStages = (stages) => {
		if(promotion.stages_mosaic_sort_mode != undefined && promotion.stages_mosaic_sort_mode == 'manual') {
			return stages.sort((a, b) => (parseInt(a.Stage.pos) < parseInt(b.Stage.pos) ? -1 : 1));
		}

		return stages.sort((a, b) => {
			switch(promotion.stages_mosaic_sort_mode) {
				case 'date':
				default:
					if(a.Stage.start_date == b.Stage.start_date) return (a.Stage.id < b.Stage.id) ? -1 : 1;
					return (a.Stage.start_date < b.Stage.start_date) ? -1 : 1;

				case 'date_inv':
					return (a.Stage.start_date > b.Stage.start_date) ? -1 : 1;

				case 'title':
					return (a.Stage?.display_title < b.Stage?.display_title) ? -1 : 1;

				case 'title_inv':
					return (a.Stage?.display_title > b.Stage?.display_title) ? -1 : 1;
			}
		}).slice(0);
	};

	const stages = sortStages(props.stagesStore.getState().stages.stages);

	const is_multistage = promotion?.is_multistage ?? false;
	const max_stages = (is_multistage) ? 20000 : 1;	// maximum number of stages to create (set to "false" if unlimited)
	const enable_different_stage_types = is_multistage;	// set to "true" when we enable to pick different promotion_type for each stage

	const participation_frequencies = [
		{ k: 'hour', v: "Hourly" },
		{ k: 'day', v: "Daily" },
		{ k: 'week', v: "Weekly" },
		{ k: 'total', v: "In total" },
	];

	const findStage = (stage_id) => {
		return stages.find((st) => (st.Stage.id == stage_id));
	};

	const mainChange = (k, v) => {
		if(k == 'stage_sections') {
			if((promotion?.stage_sections ?? []).length > v.length) {
				const new_ids = v.map((s) => (s.id));
				const removed_sections = promotion.stage_sections.filter((s) => (!new_ids.includes(s.id))).map((s) => s.id);

				if(removed_sections.length > 0) {
					const current = stages.filter((st) => removed_sections.includes(st.Stage.section_id));
					current.map((stage) => {
						props.stagesStore.dispatch({
							type:'CHANGE_STAGE',
							id:stage.Stage.id,
							k:'section_id',
							v:null,
						});
						
						$.post(getRemotedbUrl(`/promotions/savestage/${stage.Stage.promotion_id}`), stage.Stage, (res) => {
							EP.showSuccessSave();
						}).error((xhr, ajaxOptions, thrownError) => {
							throwErrorEvent(xhr.status);
						});;
					});
				}
			}
		}

		if(k == 'galleries_image' && v == null) v = '';
		if(k == 'mosaic_image' && v == null) v = '';
		if(k == 'mosaic_image' && v == null) v = '';
		if(k == 'mosaic_video' && v != '') v = parseVideo(v);

		NSchange(promotion, k, v);
		NSchange(props.pm.attributes, k, v);
		props.pm.trigger('change');

		setPromotion({ ...promotion, [k]:v });
	};

	const mainSave = (k, v) => {
		mainChange(k, v);
		props.pm.save();
	};

	const mainChangeSave = (k, v) => {
		mainChange(k, v);
	};

	const savePromo = (cb) => {
		props.pm.save((r) => {
			if(r.errors != undefined) {
				if(cb != undefined) cb();
				return;
			}

			//Replace img for the one in the server
			props.pm.attributes.header_image = r.Promotion.header_image;
			props.pm.generateThumbs();

			if(cb != undefined) cb();
		});
	};

	const getCurrentStageType = (type_id) => {
		if(type_id == undefined) return null;
		return stage_types.find((s) => (s.id == type_id));
	};

	const openCreateStageLayer = (cb) => {
		if(enable_different_stage_types) {
			setDisplayCreateStageLayer(true);

			if(cb != undefined)cb();
		} else {
			createStage(undefined, cb);
		}
	};

	const questionAssign = (res) => {
		if(res.Question != undefined) {
			props.questionsStore.dispatch({
				type:'ADDQUESTION',
				questions:[{
					Answer:[],
					Question:res.Question,
				}],
			});
		}

		if(!pm.attributes.is_multistage) {
			props.questionsStore.dispatch({
				type:'ASSIGNTOSTAGE',
				stage:res.Stage.id,
				question:res.Question,
			});

			pm.quiz_results.map((qr) => {
				qr.QuizResult.stage = res.Stage.id;
				return { ...qr };
			})

			if(promotion.config?.quiz_resume?.show ?? false) {
				const _promotion = { ...promotion };
				_promotion.config.quiz_resume.show = 0;
				setPromotion(_promotion);
			}
		}
	};

	const promoteStage = (_stage_type, id, cb) => {
		$.post(getRemotedbUrl(`/promotions/promote_stage/${promotion.id}`), {
			stage_type:_stage_type.id,
			id,
		}, (res) => {
			const st = findStage(id);

			if(st.Stage.target != undefined) {
				props.questionsStore.dispatch({
					type:'DELETEQUESTION',
					qid:st.Stage.target,
				});
			}

			props.stagesStore.dispatch({
				type:'REPLACE_STAGE',
				stage:{
					Stage:res.Stage,
				},
			});
			
			questionAssign(res);
			setPromoteStageID(false);

			if(cb != undefined) cb();
		}, 'JSON');
	};

	const createStage = (_stage_type, cb) => {
		if(_stage_type == undefined) _stage_type = stage_types.find((f) => (f.id == promotion.promotion_type_id) ? true : false);

		$.post(getRemotedbUrl(`/promotions/add_stage/${promotion.id}`), {
			stage_type:_stage_type.id,
			info:_stage_type?.data ?? {},
		}, (res) => {
			props.stagesStore.dispatch({
				type:'ADD_STAGE',
				stage:{
					Stage:res.Stage,
				},
			});

			questionAssign(res);

			if(enable_different_stage_types) setDisplayCreateStageLayer(false);
			if(cb != undefined) cb();
		}, 'JSON');
	};

	const deleteStage = (id) => {
		$.post(getRemotedbUrl(`/promotions/remove_stage/${promotion.id}`), { stage_id:id });
		props.stagesStore.dispatch({
			type:'DELETE_STAGE',
			id,
		});
		props.questionsStore.dispatch({
			type:'DELETEBYSTAGE',
			stage_id:id,
		});
	};

	const copyStage = (id) => {
		$.post(getRemotedbUrl(`/promotions/copy_stage/${promotion.id}`), { stage_id:id }, (res) => {
			props.stagesStore.dispatch({
				type:'ADD_STAGE',
				stage:{
					Stage:res.Stage,
				},
			});

			props.questionsStore.dispatch({
				type:'ADDQUESTION',
				questions:res.questions,
			});

			if(res.questions != undefined) {
				pm.questions = pm.questions.concat(res.questions);
			}

			if(res.quizresults != undefined) {
				pm.quiz_results = pm.quiz_results.concat(res.quizresults);
			}
		}, 'JSON');
	};

	const toggleHideStage = (id) => {
		const current_stage = findStage(id);

		if(current_stage.Stage.hide_stage == undefined) current_stage.Stage.hide_stage = false;
		current_stage.Stage.hide_stage = !current_stage.Stage.hide_stage;

		$.post(getRemotedbUrl(`/promotions/savestage/${promotion.id}`), current_stage, (res) => {
			EP.showSuccessSave();
		}).error((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	const toggleRecalculatePoints = (stage_id) => {
		setStageRecalculateID(stage_id);
		setStageRecalculateChanged(-1);
		setDisplayRecalculate(!display_recalculate);
	};

	/*const recalculatePointsByStage = (e, cb) => {
		if(stage_recalculate_id === false) return;

		const st = findStage(stage_recalculate_id);

		if(st.Stage.promotion_type_id == 44) {
			$.post(getRemotedbUrl(`/stages/recalculate_team/${promotion.id}/${st.Stage.id}`), (res) => {
				setStageRecalculateChanged(res.updated);
				if(cb != undefined) cb();
			}, 'JSON');
			return;
		}

		$.post(getRemotedbUrl(`/quizs/recalculate/${promotion.id}/${stage_recalculate_id}`), (res) => {
			setStageRecalculateChanged(res.changed);
			if(cb != undefined) cb();
		}, 'JSON');
	};*/

	const onSortEnd = ({ oldIndex, newIndex }) => {
		let _stages = sortStages(props.stagesStore.getState().stages.stages).filter((st) => {
			if(parseInt(st.Stage.promotion_type_id) == spt.MEDIA_AUTOCONTENT.id) return false;
			return true;
		});

		_stages = arrayMove(_stages, oldIndex, newIndex);

		const data = {};
		for(let i in _stages) {
			data[_stages[i].Stage.id] = i;
		}

		props.stagesStore.dispatch({
			type:'SORT_STAGES',
			order:data,
		});

		$.post(getRemotedbUrl(`/stages/setorder/${promotion.id}`), { order:data });
	};

	const changeCssVariable = (_promo) => {
		if(window.css_var.setCustomStyles != undefined) {
			window.css_var.setCustomStyles(getLayout(_promo));
		}
	};

	const changeLayout = (scope, k, v) => {
		setPromotion((promotion) => {
			const _promotion = { ...promotion };
			if(_promotion.layout_props == undefined) _promotion.layout_props = {};
			if(_promotion.layout_props[scope] == undefined) _promotion.layout_props[scope] = {};
			
			_promotion.layout_props = {..._promotion.layout_props, [scope]:{ ..._promotion.layout_props[scope], [k]:v }};
			if(v == null) delete _promotion.layout_props[scope][k];
			if(k.indexOf('image') != -1 && v === "") delete _promotion.layout_props[scope][k];
			
			NSchange(props.pm.attributes, 'layout_props', _promotion.layout_props);
			changeCssVariable(_promotion);

			return _promotion;
		});
	};

	let filtered_stages = [];
	let non_filtered_stages = [];

	const non_filtered_stages_foo = {
		Stage:{
			id:'0',
			display_title:i18n("Expired stages (hidden)"),
			start_date:EPDateFormat(null, 'YYYY-MM-DD HH:mm:ss'),
			end_date:promotion.start_date,
		},
	};

	const media_list = {};
	stages.map((stage) => {
		media_list[stage.Stage.id] = getStageName(stage.Stage, i18n);
	});

	let has_expired_stages = false;
	let has_real_expired_stages = false;

	let countable_stages = 0;
	const is_wl = (promotion.promo_type == '2') ? true : false;

	let total_stages = 0;

	stages.map((st) => {
		if(!has_real_expired_stages && EPDateAfter(null, st.Stage.end_date)) has_real_expired_stages = true;
		if(parseInt(st.Stage.promotion_type_id) == spt.MEDIA_AUTOCONTENT.id) return;

		countable_stages++;

		if(display_expired_stages) {
			filtered_stages.push(st);
		} else if(EPDateBefore(null, st.Stage.end_date)) {
			filtered_stages.push(st);
		} else {
			if(EPDateBefore(non_filtered_stages_foo.Stage.end_date, st.Stage.end_date)) {
				non_filtered_stages_foo.Stage.end_date = st.Stage.end_date;
			}

			if(EPDateAfter(non_filtered_stages_foo.Stage.start_date, st.Stage.start_date)) {
				non_filtered_stages_foo.Stage.start_date = st.Stage.start_date;
			}

			has_expired_stages = true;
		}
		total_stages++;
	});

	if(has_expired_stages) non_filtered_stages.push(non_filtered_stages_foo);

	const CreateNewStageElement = (enable_different_stage_types) ? CreateButton : SaveButton;

	const section_main_path = 'stages';
	let sections = [];

	const is_draft = (promotion.status == '0') ? true : false;

	const stage_count = (!display_expired_stages) ? `${filtered_stages.length}/${total_stages}` : `${total_stages}`;
	const section_title = <span>{i18n("Stages")}<span class="gui_not_in_start_small">[{stage_count}]</span></span>;

	let brackets = [];
	if(props.bracketsStore != undefined) {
		let bts = props.bracketsStore.getState();
		brackets = bts.brackets != undefined ? bts.brackets.brackets : [];
	}

	const is_sections_enabled = promotion?.sections_enabled ?? false;

	let sortable_stages = [{ k:'', v:i18n("See sections") }];
	if(!is_sections_enabled) {
		sortable_stages = [
			{ k:'date', v:`${i18n("By opening date")} (${i18n("ASC")})` },
			{ k:'date_inv', v:`${i18n("By opening date")} (${i18n("DESC")})` },
			{ k:'title', v:`${i18n("By stage name")} (${i18n("ASC")})` },
			{ k:'title_inv', v:`${i18n("By stage name")} (${i18n("DESC")})` },
			{ k:'manual', v:i18n("Manual") },
		];
	}

	let stage_sections = [{ id:'no_section' }];
	if(is_sections_enabled && promotion.stage_sections != undefined) {
		stage_sections = [
			...promotion.stage_sections,
			{
				id:'no_section',
				title:`[ ${i18n("No section")} ]`,
				color:'#000000',
			},
		];
	}

	const media_stages = filtered_stages.filter((s) => ([
		stage_categories.ID_MEDIA_CATEGORY.id,
		stage_categories.ID_PHOTO_FUN.id,
	].includes(parseInt(s.Stage.type))));

	const has_media_stages = (media_stages.length > 0) ? true : false;
	
	const gallery_stages = filtered_stages.filter((s) => (s.Stage.type == stage_categories.ID_VOTING_CATEGORY.id));
	const has_gallery_stages = (gallery_stages.length > 0) ? true : false;

	const score_predictor_stages = stages.filter((s) => ([spt.SCORE_PREDICTOR.id, spt.BRACKET_PREDICTOR.id].includes(parseInt(s.Stage.promotion_type_id))));
	const has_score_predictor_stages = score_predictor_stages.length > 0 ? true : false;

	const is_media_autocontent = (promotion.promotion_type_id == spt.MEDIA_AUTOCONTENT.id) ? true : false;
	const is_video_contest = (promotion.promotion_type_id == spt.VIDEO_CONTEST.id) ? true : false;

	const enable_multistage = (is_wl && is_multistage) ? true : false;
	
	if(published) {
		const in_stages = (window.location.hash == `#${section_main_path}` || window.location.hash == `#${section_main_path}/calendar`) ? true : false;

		sections.push({
			label:"Stages",
			link:section_main_path,
			icon:'knk-view-compressed',
			selected:(in_stages) ? true : false,
		});

		if((enable_multistage || is_media_autocontent) && is_wl) {
			sections.push({
				label:i18n("Stages list page"),
				link:`${section_main_path}/manager/1`,
				icon:'knk-profile',
				autotranslate:false,
			});
		}

		if(!enable_multistage && is_video_contest) {
			sections.push({
				label:i18n("Stage page"),
				link:`${section_main_path}/manager/1`,
				icon:'knk-profile',
				autotranslate:false,
			});
		}

		if(has_gallery_stages) {
			sections.push({
				label:"Galleries public page",
				link:`${section_main_path}/galleries`,
				icon:'knk-quiz',
			});
		}

		if(enable_multistage && countable_stages > 1 && is_wl) {
			sections.push({
				label:"Sections",
				link:`${section_main_path}/sections`,
				icon:'knk-groups',
			});
		}

		if(has_media_stages || is_media_autocontent || has_gallery_stages) {
			sections.push({
				label:"Candidate management",
				link:`${section_main_path}/categories`,
				icon:'knk-entries',
			});
		}

		if(has_score_predictor_stages) {
			sections.push({
				label:"Teams management",
				link:`${section_main_path}/teams`,
				icon:'knk-football-team-shirt',
			});
		}
	}

	const are_galleries_public = promotion?.galleries_enabled ?? false;
	const display_tabs = (sections.length > 1) ? true : false;

	return (
		<Router hashType="noslash">
			<Switch>
				<Route exact={true} path={`/${section_main_path}`} render={(route) => {
					return (
						<BuilderMainWithoutSidebar pm={props.pm} has_tabs={display_tabs}>
							{(display_tabs) && (
								<NavigationTabsBuilder
									active={route.location.pathname}
									sections={sections}
								/>
							)}

							<section class="not_awesome">
								<div class="gui_section_header alone_section_header cleared_header">
									<SectionTitle
										_class={{ other:'in_top' }}
										autotranslate={false}
									>{section_title}</SectionTitle>

									{(countable_stages > 1 && has_real_expired_stages && is_multistage) && (
										<div class="gui_not_in_start">[<ActionLink
											onClick={() => setDisplayExpiredStages(!display_expired_stages)}
										>{(!display_expired_stages) ? "Show expired" : "Hide expired"}</ActionLink>]</div>
									)}

									{(filtered_stages.length > 1 && is_multistage) && (
										<div class="gui_not_in_start">[<ActionLink
											_href={`#${section_main_path}/calendar`}
										>Calendar view</ActionLink>]</div>
									)}

									{(stage_types.length > 0) && (
										<div class="combined_header_options">
											<ButtonCollection
												_class={{ other:'gui_flex_end' }}
											>
												{(countable_stages > 1) && (
													<Select
														name="stages_mosaic_sort_mode"
														model={promotion}
														change={mainSave}
														_class={{ first: true, size: 80 }}
														values={sortable_stages}
														disabled={is_sections_enabled}
													>Order</Select>
												)}

												{(countable_stages < max_stages && enable_multistage && is_wl) ? (
													<CreateNewStageElement
														icon='knk-add-item'
														onClick={(e, cb) => openCreateStageLayer(cb)}
													>New stage</CreateNewStageElement>
												) : (
													<CreateNewStageElement
														icon='knk-add-item'
														tooltip={<Tooltip
															with_icon={false}
															position="left"
														>Contact sales team to learn more about multiple stages</Tooltip>}
														disabled={true}
													>New stage</CreateNewStageElement>
												)}
											</ButtonCollection>
										</div>
									)}
								</div>

								<div class="gui_table_with_graphic" style={{ maxHeight: 'calc(100dvh - 240px)' }}>
									{(countable_stages > 0 && filtered_stages.length > 0) && (
										<div class="not_in_top in_bottom">
											{stage_sections.map((section, s) => {
												const stages_in_section = filtered_stages.filter((s) => {
													const _st = s.Stage;
													if(!is_sections_enabled || (section.id == 'no_section' && _st.section_id == undefined)) return true;
													return (_st.section_id == section.id) ? true : false;
												});

												if(is_sections_enabled && stages_in_section.length == 0 && section.id == 'no_section') return null;

												return (
													<SortableFields
														key={`stage_${s}`}
														index={s + 1}
														items={stages_in_section}
														brackets={brackets}
														data={{
															is_multistage,
															is_sortable:promotion.stages_mosaic_sort_mode,
															is_sections_enabled,
															section,
															end_date:promotion.end_date,
															start_date:promotion.start_date,
															start_entry:promotion.start_entry,
															participation_frequencies,
															num_stages:stage_count,
															get_stage_type:getCurrentStageType,
															recalculate_points:toggleRecalculatePoints,
															toggle_hide_stage:toggleHideStage,
															promote:(stage_id) => setPromoteStageID(stage_id),
															copy_stage:copyStage,
															delete_stage:deleteStage,
															stages,
															media_list,
															is_wl,
															is_draft,
															promotion_type_id:promotion.promotion_type_id,
															intl:props.intl,
															promotion
														}}
														onSortStart={() => preventSelection(true)}
														onSortEnd={onSortEnd}
														useDragHandle={true}
													/>
												)
											})}
										</div>
									)}

									{(has_gallery_stages > 0) && (
										<div class="gui_is_not_padded gui_not_in_top_huge" style={{ overflow:'visible' }}>
											<Message
												_class={{ other:'in_top in_bottom' }}
											>
												<p><strong>{i18n((are_galleries_public) ? "The galleries are public." : "The galleries are not public.")}</strong> {i18n((are_galleries_public) ? "Unregistered visitors to the contest can access the galleries." : "Only contest-registered users can access the galleries.")} <ActionLink _href='#stages/galleries'>Configure</ActionLink>.</p>
											</Message>
										</div>
									)}

									{(countable_stages > 0 && filtered_stages.length < 1) && (
										<div class="gui_is_not_padded not_in_top">
											<Message
												_class={{ other:'in_top in_bottom' }}
											>
												<p>
													<FormattedMessage
														id="The filter returned no stages. {link} to view all stages."
														values={{
															link:<ActionLink
																onClick={() => setDisplayExpiredStages(!display_expired_stages)}
																autotranslate={false}
															>{i18n("Click here", 'ucfirst')}</ActionLink>,
														}}
													/>
												</p>
											</Message>
										</div>
									)}

									{(countable_stages < 1) && (
										<div class="gui_is_not_padded not_in_top">
											<AlertMessage
												_class={{ other:'in_top in_bottom' }}
											>
												{(is_multistage && max_stages > 1) ? (
													<p>{i18n("You need to create at least one stage.")}</p>
												) : (
													<p>{i18n("You need to create a stage.")}</p>
												)}
											</AlertMessage>
										</div>
									)}
								</div>
							</section>

							{/*(display_recalculate !== false) && (
								<FloatingLayer
									_class={{ size:'small' }}
									enable_close={false}
								>
									<div>
										<SectionTitle>Recalculate points</SectionTitle>

										<SectionSubtitle>This action allows you to recalculate the points of the participants of this stage according to the points of the answers of the pool.</SectionSubtitle>

										<SectionSubtitle>Use this action to update the scoreboard, once you know the results of the pool and have assigned the points to the correct answers.</SectionSubtitle>

										{(stage_recalculate_changed >= 0) && (
											<div class="greenColor">
												<FormattedMessage
													id="Operation successful: {total_changed} users updated"
													values={{
														total_changed:stage_recalculate_changed,
													}}
												/>
											</div>
										)}

										<ButtonCollection in_floating={true}>
											<SecondaryButton
												onClick={toggleRecalculatePoints}
											>Close</SecondaryButton>

											{(stage_recalculate_changed < 0) && (
												<SaveButton
													onClick={recalculatePointsByStage}
												>Recalculate points now</SaveButton>
											)}
										</ButtonCollection>
									</div>
								</FloatingLayer>
							)*/}
						</BuilderMainWithoutSidebar>
					)
				}} />

				<Route exact={true} path={`/${section_main_path}/calendar`} render={(route) => {
					if(!(is_multistage && filtered_stages.length > 0)) window.location.hash = section_main_path;

					return (
						<BuilderMainWithoutSidebar pm={props.pm} has_tabs={true}>
							<NavigationTabsBuilder
								active={route.location.pathname}
								sections={sections} 
							/>

							<section class="not_awesome"> 
								<div class="gui_section_header alone_section_header cleared_header">
									<SectionTitle
										_class={{ other:'in_top' }}
										autotranslate={false}
									>{section_title}</SectionTitle>

									{(countable_stages > 0 && has_real_expired_stages && is_multistage) && (
										<div class="gui_not_in_start">[<ActionLink
											onClick={() => setDisplayExpiredStages(!display_expired_stages)}
										>{(!display_expired_stages) ? "Show expired" : "Hide expired"}</ActionLink>]</div>
									)}

									<div class="gui_not_in_start">[<ActionLink
										_href={`#${section_main_path}`}
									>List view</ActionLink>]</div>

									{(stage_types.length > 0) && (
										<div class="combined_header_options">
											<DisabledArea
												disabled={(countable_stages >= max_stages && !is_multistage) ? true : false}
												message="Contact sales team to learn more about multiple stages"
												tooltip_position="left"
											>
												<CreateNewStageElement
													icon='knk-add-item'
													onClick={(e, cb) => openCreateStageLayer(cb)}
												>New stage</CreateNewStageElement>
											</DisabledArea>
										</div>
									)}
								</div>

								<div class="gui_table_with_graphic" style={{ maxHeight:'calc(100dvh - 240px)' }}>
									<div class="visual_stages_graphic">
										<DatesMap
											promo={promotion}
											stages={filtered_stages}
											out_stages={non_filtered_stages}
										/>
									</div>
								</div>
							</section>
						</BuilderMainWithoutSidebar>
					)
				}} />

				<Route path={`/${section_main_path}/brackets`} render={(route) => {
					return (
						<Provider store={props.bracketsStore}>
							<BracketsBuilder
								stages={stages}
								promotion={props.pm.attributes}
								promoModel={props.pm}
								stageStore={props.stagesStore}
								questionsStore={props.questionsStore}
							/>
						</Provider>
					)
				}} />

				<Route path={`/${section_main_path}/galleries`} render={(route) => {
					return (
						<StageGalleries
							createStage={openCreateStageLayer}
							pm={promotion}
							promoModel={props.pm}
							promoChange={mainChangeSave}
							questions={pm.questions}
							questionsStore={props.questionsStore}
							savePromo={savePromo}
							stages={stages}
							sections={sections}
							stagesStore={props.stagesStore}
						/>
					)
				}} />

				<Route path={`/${section_main_path}/categories`} render={(route) => {
					return (
						<StageContentCategories
							basePath={`/${section_main_path}/categories`}
							promoModel={props.pm}
							promotion={props.pm.attributes}
							stages={stages}
							sections={sections}
							stagesStore={props.stagesStore}
							createStage={createStage}
							deleteStage={deleteStage}
						/>
					)
				}} />

				<Route path={`/${section_main_path}/teams`} render={(route) => {
					return (
						<StageTeamsManagement
							basePath={`/${section_main_path}/teams`}
							promoModel={props.pm}
							promotion={props.pm.attributes}
							promoChange={mainSave}
							stages={stages}
							sections={sections}
							stagesStore={props.stagesStore}
						/>
					)
				}} />

				<Route path={`/${section_main_path}/manager`} exact={true} render={(route) => {
					return (
						<StageManager />
					)
				}} />

				<Route path={`/${section_main_path}/sections`} exact={true} render={(route) => {
					return (
						<StageSections
							createStage={openCreateStageLayer}
							mainSave={mainSave}
							pm={promotion}
							promoModel={props.pm}
							promoChange={mainChange}
							promoChangeSave={mainSave}
							questions={pm.questions}
							questionsStore={props.questionsStore}
							savePromo={savePromo}
							changeLayout={changeLayout}
							stages={stages}
							sections={sections}
							stagesStore={props.stagesStore}
						/>
					)
				}} />

				<Route path={`/${section_main_path}/manager/:type`} render={(route) => {
					if(!is_multistage) window.location.hash = section_main_path;

					return (
						<>
							{(display_create_stage_layer !== false) && (
								<CreateStageOverlay
									closeCreateStageLayer={() => setDisplayCreateStageLayer(false)}
									createStage={createStage}
									intl={props.intl}
									stage_types={stage_types}
									promo_type={promotion.promotion_type_id}
									promotion_types={props.promotion_types}
								/>
							)}

							<StageManagerEdit
								createStage={openCreateStageLayer}
								pm={promotion}
								promoModel={props.pm}
								promoChange={mainChangeSave}
								questions={pm.questions}
								questionsStore={props.questionsStore}
								savePromo={savePromo}
								stages={stages}
								sections={sections}
								stagesStore={props.stagesStore}
							/>
						</>
					)
				}} />

				<Route path={`/${section_main_path}/:id`} render={(route) => {
					const id = route.match.params.id;
					return (
						<StageEdit
							codesets={props.pm.attributes.codeSets}
							instantStore={props.instantStore}
							pm={promotion}
							promoModel={props.pm}
							prizes={props.prizes}
							route={route}
							stages={stages}
							stage={stages.find((s) => (s.Stage.id == id))}
							store={props.questionsStore}
							winnerStore={props.winnerStore}
							bracketsStore={props.bracketsStore}
							stagesStore={props.stagesStore}
							loyaltyTokensStore={props.loyaltyTokensStore}
							validationSitesStore={props.validationSitesStore}
							isCorporate={props.isCorporate}
							available_languages={props.available_languages}
							promoChangeSave={mainSave}
						/>
					)
				}} />
			</Switch>

			{(display_create_stage_layer !== false) && (
				<CreateStageOverlay
					closeCreateStageLayer={() => setDisplayCreateStageLayer(false)}
					createStage={createStage}
					intl={props.intl}
					stage_types={stage_types}
					promo_type={promotion.promotion_type_id}
					promotion_types={props.promotion_types}
				/>
			)}

			{(promote_stage_id !== false) && (
				<PromoteStageOverlay
					stage_id={promote_stage_id}
					actual_stage={stages.find((s) => (s.Stage.id == promote_stage_id))}
					close={() => setPromoteStageID(false)}
					createStage={promoteStage}
					stage_types={stage_types}
					promo_type={promotion.promotion_type_id}
					promotion_types={props.promotion_types}
					intl={props.intl}
				/>
			)}
		</Router>
	)
};

function select(state) {
	return state;
};

export default connect(select)(injectIntl(StagesBuilder))